module.exports = __webpack_public_path__ + "img/step1.d383b316.png";